import {NgModule}                         from '@angular/core';
import {
  FieldOverviewComponent
}                                         from './components/field-overview.component';
import {
  BodyModule,
  GridModule,
  HeaderModule,
  PagerContextService,
  PagerModule,
  SharedModule
}                                         from '@progress/kendo-angular-grid';
import {CommonModule}                     from '@angular/common';
import {
  ApTranslationModule
}                                         from '../translation/ap-translation.module';
import {
  ApCoreModule
}                                         from '../ap-core/ap-core.module';
import {
  ApIconModule
}                                         from '../icons/ap-icon.module';
import {
  ButtonModule,
  SplitButtonModule
}                                         from '@progress/kendo-angular-buttons';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  LayoutModule
}                                         from '@progress/kendo-angular-layout';
import {
  InputsModule
}                                         from '@progress/kendo-angular-inputs';
import {
  ComboBoxModule,
  DropDownsModule
}                                         from '@progress/kendo-angular-dropdowns';
import {
  DateInputsModule
}                                         from '@progress/kendo-angular-dateinputs';
import {
  ApFieldmanagementRoutes
}                                         from './ap-fieldmanagement.routes';
import {
  ApLayoutModule
}                                         from '../layout/ap-layout.module';
import {
  ApCampaignyearCropConverterPipe
}                                         from './pipes/ap-campaignyear-crop-converter.pipe';
import {ApUtilsModule}                    from '../ap-utils';
import {
  ApDynComponentModule
}                                         from '../ap-dyncomponent/ap-dyncomponent.module';
import {
  ApCropRotationComponent
}                                         from './components/ap-crop-rotation/ap-crop-rotation.component';
import {
  ApStatisticsModule
}                                         from '../statistics/ap-statistics.module';
import {
  ApResponsiveTextModule
}                                         from '../ap-responsive-text/ap-responsive-text.module';
import {
  ApSectionHeaderModule
}                                         from '../ap-section-header/ap-section-header.module';
import {
  ApCropRotationModule
}                                         from '../ap-crop-rotation/ap-crop-rotation.module';
import {
  ApPermissionModule
}                                         from '../ap-permission/ap-permission.module';
import {
  ApGetFieldNamePipe
}                                         from './pipes/ap-get-field-name.pipe';
import {
  ApSamplefieldsComponent
}                                         from './components/ap-samplefields/ap-samplefields.component';
import {
  NdiComponent
}                                         from './components/ndi/ndi.component';
import {
  ApElevationComponent
}                                         from './components/ap-elevation.component';
import {
  ApSoilScanComponent
}                                         from './components/ap-soil-scan.component';
import {
  MonitoringComponent
}                                         from './components/ap-monitoring/monitoring.component';
import {
  ApReportsModule
}                                         from '../ap-reports/ap-reports.module';

@NgModule({
  declarations: [
    FieldOverviewComponent,
    ApCampaignyearCropConverterPipe,
    ApCropRotationComponent,
    ApGetFieldNamePipe,
    ApSamplefieldsComponent,
    NdiComponent,
    ApElevationComponent,
    ApSoilScanComponent,
    MonitoringComponent
  ],
  exports: [
    FieldOverviewComponent,
    ApCampaignyearCropConverterPipe,
    ApGetFieldNamePipe,
    ApSamplefieldsComponent,
    ApElevationComponent,
    ApSoilScanComponent,
    MonitoringComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ApCoreModule,
    ApIconModule,
    LayoutModule,
    ApStatisticsModule,
    ButtonModule,
    ApLayoutModule,
    SplitButtonModule,
    InputsModule,
    ComboBoxModule,
    DateInputsModule,
    DropDownsModule,
    FormsModule,
    GridModule,
    ApTranslationModule,
    ApFieldmanagementRoutes,
    SharedModule,
    BodyModule,
    ApUtilsModule,
    PagerModule,
    HeaderModule,
    ApSectionHeaderModule,
    ApResponsiveTextModule,
    ApDynComponentModule,
    ApCropRotationModule,
    ApPermissionModule,
    ApReportsModule,
  ],
  providers: [
    ApCampaignyearCropConverterPipe,
    ApGetFieldNamePipe,
    PagerContextService
  ]
})
export class ApFieldManagementModule {
}
